module.exports = "/_next/static/images/hm-e875a51ef2beb891fd6f4b9e117a243e.svg";